import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { plainText } from "@/lib/conceptGuidance";

interface Props {
  abstract: string;
  onEdit: () => void;
  onConfirm: () => void;
}

/** Shown on Curate while concept.abstract_auto_drafted — the grading rubric was
 *  written by PaperChase, so the user should check it before trusting scores. */
export function DraftedQuestionCallout({ abstract, onEdit, onConfirm }: Props) {
  return (
    <div className="flex items-start gap-3 rounded-md border border-primary/30 bg-primary/5 px-4 py-3">
      <Sparkles className="mt-0.5 size-4 shrink-0 text-primary" />
      <div className="flex-1 space-y-1.5">
        <p className="text-sm font-medium">PaperChase drafted your research question</p>
        <p className="text-xs text-muted-foreground">
          Check it — every paper is graded against it.
        </p>
        <p className="text-xs leading-relaxed text-foreground/90">{plainText(abstract)}</p>
      </div>
      <div className="flex shrink-0 gap-2">
        <Button variant="outline" size="sm" onClick={onEdit}>Edit</Button>
        <Button size="sm" onClick={onConfirm}>Looks right</Button>
      </div>
    </div>
  );
}
